var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 496 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.976 161.402L31.9763 1.40247C23.1765 -1.79673 13.2566 0.602625 6.69597 7.32247C0.136455 14.0429 -1.78354 24.1231 1.73614 32.9229L48.4373 149.896C50.8649 155.975 56.7507 159.963 63.2966 159.963H186.536C199.816 159.963 210.536 170.683 210.536 183.963C210.536 197.242 199.816 207.963 186.536 207.963H63.2966C56.7507 207.963 50.8649 211.95 48.4373 218.03L1.73614 335.003C-1.78338 343.803 0.136455 353.883 6.69614 360.603C11.3366 365.402 17.576 367.963 23.9763 367.963C26.696 367.963 29.4168 367.482 31.9763 366.522L479.976 206.522C489.576 203.163 495.976 194.043 495.976 183.963C495.976 173.883 489.576 164.763 479.976 161.402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatIcon);
export default __webpack_public_path__ + "static/media/send-chat-icon.8f7adf3fd15afa1db69980dcf49be2a8.svg";
export { ForwardRef as ReactComponent };